import styled, { css } from 'styled-components';
import {
  Select,
} from 'components';

export const TextLine = styled.div`
  display: flex;
  align-items: center;
  color: #5d5d5d;
`;

export const CustomSelect = styled(Select)`
  margin-bottom: 11px;
  margin-right: 50px;
`;

export const HeaderCollapsible = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;

  &:hover {
    background: rgba(0,0,0,0.02);
  }
`;

export const TitleCollapsible = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  color: #444;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #ccc;
  }
`;

export const IconCollapsible = styled.span<{ $open: boolean }>`
  display: inline-block;
  transition: transform 200ms ease;
  transform: rotate(0deg);
  ${(p) => p.$open && css`transform: rotate(180deg);`}
`;

export const ContentOuterCollapsible = styled.div<{ $height: number }>`
  overflow: hidden;
  transition: max-height 240ms ease;
  max-height: ${(p) => p.$height}px;
`;

export const ContentInnerCollapsible = styled.div`
  padding: 12px 0px 16px 0px;
  font-size: 14px;
  color: #333;
`;
